import jwtDecode from 'jwt-decode'
import { useEffect, useRef } from 'react'
import { DOMAIN } from '@/config'
import { supabase } from '@/client'

export const GoogleLogin = ({ className, setIsMember }) => {
  const { ipcRenderer } = window.electron
  const loginEl = useRef()
  useEffect(() => {
    const google = window.google
    if (google) {
      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        auto_select: false,
        callback: async (res) => {
          const resData = jwtDecode(res.credential)

          if (resData.hd !== DOMAIN) {
            setIsMember(false)
            return
          }

          const { email, name } = resData

          await supabase.auth.signInWithIdToken({
            provider: 'google',
            token: res.credential, // Google에서 받은 ID Token
          })

          const { data: userData } = await supabase.from('users').select('*').eq('email', email)

          // Supabase 세션 토큰 가져오기
          const {
            data: { session },
          } = await supabase.auth.getSession()

          // 사용자 이미 등록 여부 확인
          if (userData && userData.length > 0) {
            // 이미 등록된 사용자 - 바로 로그인
            ipcRenderer.send('login', { email, name, id: userData[0].id })
            return
          }

          // 신규 사용자 - Edge Function으로 생성
          const functionUrl = `${process.env.REACT_APP_SUPABASE_API_URL}/functions/v1/create-user`
          const result = await fetch(functionUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${session?.access_token}`,
            },
            body: JSON.stringify({ email, name }),
          }).then((res) => res.json())

          if (!result.success) {
            console.error('User creation failed:', result.error)
            setIsMember(false)
            return
          }

          // 생성된 사용자로 로그인
          const { data: newUserData } = await supabase.from('users').select('*').eq('email', email)
          ipcRenderer.send('login', { email, name, id: newUserData[0].id })
        },
      })
      google.accounts.id.prompt()
      window.google.accounts.id.renderButton(loginEl.current, {
        theme: 'outline',
        size: 'large',
        text: 'login',
        width: 300,
        logo_alignment: 'center',
      })
    }
  }, [])

  return <div ref={loginEl} className={`google-login ${className}`}></div>
}
